import {
  backendConfigured,
  fetchWorkerModels,
  runWorkerAudit,
  runWorkerFollowUp,
  validateProviderWithWorker,
} from "./backend";

export const AI_PROVIDERS = [
  {
    id: "openrouter",
    name: "OpenRouter",
    shortName: "OpenRouter",
    keyPlaceholder: "sk-or-v1-…",
    keyUrl: "https://openrouter.ai/settings/keys",
    defaultModel: "openrouter/free",
    supportsFreeModels: true,
    description: "Hundreds of providers plus a live catalog of zero-cost models.",
  },
  {
    id: "openai",
    name: "OpenAI",
    shortName: "OpenAI",
    keyPlaceholder: "sk-proj-…",
    keyUrl: "https://platform.openai.com/api-keys",
    defaultModel: "gpt-5.4-nano",
    supportsFreeModels: false,
    description: "Direct Responses API with structured JSON output.",
  },
  {
    id: "gemini",
    name: "Google Gemini",
    shortName: "Gemini",
    keyPlaceholder: "AIza…",
    keyUrl: "https://aistudio.google.com/app/apikey",
    defaultModel: "gemini-3-flash-preview",
    supportsFreeModels: false,
    description: "Direct generateContent API; account free-tier limits may apply.",
  },
  {
    id: "anthropic",
    name: "Anthropic Claude",
    shortName: "Claude",
    keyPlaceholder: "sk-ant-…",
    keyUrl: "https://console.anthropic.com/settings/keys",
    defaultModel: "claude-haiku-4-5",
    supportsFreeModels: false,
    description: "Direct Messages API with structured output-capable Claude models.",
  },
];

export const DEFAULT_PROVIDER = "openrouter";

export function getProvider(providerId) {
  return AI_PROVIDERS.find((item) => item.id === providerId) || AI_PROVIDERS[0];
}

export function providerSessionKey(providerId) {
  return `gtm-atlas-${providerId}-key`;
}

export async function validateProviderKey(provider, apiKey, signal) {
  ensureWorker();
  ensureKey(provider, apiKey);
  const payload = await validateProviderWithWorker(provider, apiKey, signal);
  return payload.data || payload;
}

export async function fetchProviderModels(provider, apiKey, signal) {
  ensureWorker();
  ensureKey(provider, apiKey);
  return fetchWorkerModels(provider, apiKey, signal);
}

export async function runAiAudit({
  provider,
  apiKey,
  model,
  auditPayload,
  signal,
}) {
  ensureWorker();
  ensureKey(provider, apiKey);
  if (!auditPayload) throw new Error("Analyze a GTM container before requesting an AI review.");
  const config = getProvider(provider);
  return runWorkerAudit({
    provider,
    apiKey,
    model: model?.trim() || config.defaultModel,
    auditPayload,
    signal,
  });
}

export async function runAiFollowUp({
  provider,
  apiKey,
  model,
  auditPayload,
  priorReview,
  conversation,
  question,
  signal,
}) {
  ensureWorker();
  ensureKey(provider, apiKey);
  const config = getProvider(provider);
  return runWorkerFollowUp({
    provider,
    apiKey,
    model: model?.trim() || config.defaultModel,
    auditPayload,
    priorReview,
    conversation,
    question,
    signal,
  });
}

function ensureWorker() {
  if (!backendConfigured()) {
    throw new Error(
      "AI providers require the Cloudflare Worker. Set VITE_API_BASE_URL and restart the app.",
    );
  }
}

function ensureKey(provider, apiKey) {
  if (!apiKey?.trim()) {
    throw new Error(`Enter your ${getProvider(provider).shortName} API key first.`);
  }
}
